import {Box, Typography} from '@viptech/react-components'
import ReactPlayer from 'react-player'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'

const DigifortGuide = () => {
  const service = '{"device_name": "$(DEVICE_NAME)"}'
  const {styledTheme} = usePersonalizedThemeByCompany()
  return (
    <Box display='flex' direction='column' backgroundColor='white' borderRadius='8px' padding='30px' overflow='auto' rowGap='30px'>
      <Box>
        <Typography variant='p' size='16px' weight={700} color={styledTheme.colors.primary}>
          Tutorial de integração Digifort com o Brain!
        </Typography>
        <Typography variant='span' size='14px' color={'#5e6168'}>
          Abaixo você encontra um passo-a-passo com informações adicionais para configurar seu vms e um vídeo explicando de forma detalhada como completar a
          integração.
        </Typography>
      </Box>

      <Box display='flex' direction='column' rowGap='10px'>
        <Typography variant='p' size='14px'>
          Tipo de requisição: POST
        </Typography>

        <Typography variant='p' size='14px'>
          No campo URL, insira o seguinte link: <b>{process.env.REACT_APP_BASE_URL}/digifort-integration/trigger</b>
        </Typography>

        <Typography variant='p' size='14px'>
          Nos campos "Usuário" e "Senha" devem ser inseridas as credenciais de acesso pragmático geradas na plataforma do Brain
        </Typography>

        <Typography variant='p' size='14px'>
          Por fim, no campo "Dados", deve ser inserido o seguinte valor: <b>{service}</b>
        </Typography>
      </Box>

      <Box margin='10px'>
        <Typography variant='p' size='14px' weight={500}>
          O vídeo a seguir explica de forma detalhada os passos para completar a integração:
        </Typography>

        <ReactPlayer url='https://youtu.be/p-x8vegmlo0' controls={true} />
      </Box>
    </Box>
  )
}

export default DigifortGuide
